import { render, staticRenderFns } from "./SearchComplaint.vue?vue&type=template&id=47a8ae27"
import script from "./SearchComplaint.vue?vue&type=script&lang=js"
export * from "./SearchComplaint.vue?vue&type=script&lang=js"
import style0 from "./SearchComplaint.vue?vue&type=style&index=0&id=47a8ae27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports